import { connect } from "react-redux";
import ApprovalList from "./approvalList";
import { bindActionCreators } from "redux";
import { getApprovalList, acceptApproval, rejectApproval } from "services/redux/approvals/salesApprovals/action"
import { getContractDetails } from "services/redux/sales/preSaleListing/action"
import { saveAllContractLogs} from "services/redux/approvals/salesApprovals/action";
import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { getSearchUser } from "services/redux/tickets/createTicket/action";


const mapStateToProps = (state) => ({
  approvalList: state.salesApprovalReducer.approvalList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  viewDetails: state.preSalesListReducer.viewContract,
  saveModificationLog: state.salesApprovalReducer.saveModificationLog
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getApprovalList,
    acceptApproval,
    rejectApproval,
    fetchZones,
    getListFilterData,
    getContractDetails,
    documentUploadUrlPublic,
    saveAllContractLogs,
    getSearchUser,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalList);
